import { InfoIcon } from '@assets/icons';
import { type SxProps } from '@mui/material';
import { ServerTag } from '../ServerTag';

export const UserResourceWarning = ({ sx, resource }: { sx?: SxProps; resource: string }) => {
  return (
    <ServerTag
      label={
        <>
          <InfoIcon size={14} style={{ flexShrink: 0 }} /> User {resource} only apply to servers
          created by each user
        </>
      }
      color="user"
      variant="caption2"
      sx={{
        lineHeight: '24px',
        py: 0,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        ...sx,
      }}
    />
  );
};
